import { useState } from "react";
import { FiltersContainer } from "./Styled";
import { AddToDashboardWrapper } from "app/components/React/TopSites/DomainsTable/AddToDashboard";
import { DefaultFetchService } from "app/services/fetchService";
import { WebsiteTypeFilter } from "pro-features/components/filtersPanel/src/WebsiteTypeFilter";
import { useNoRenderA2D } from "app/pages/industry-analysis/frame/WithNoRender";
import { SearchAndUtils } from "app/components/React/table-top/SearchAndUtils";

export const resolveExcelLink = (
    excelEndpoint: string,
    filtersStateObject: any,
    sort: { field: string; sortDirection: string },
) => {
    const fetcherService = DefaultFetchService.getInstance();
    const urlParams = {
        ...filtersStateObject,
        orderBy: `${sort.field}${sort.sortDirection === "desc" ? ` ${sort.sortDirection}` : ""}`,
    };
    const excelLink = `/${excelEndpoint}?${fetcherService.requestParams(urlParams)}`;
    return excelLink;
};

interface WithField {
    field: string;
}

type TableTopProps = {
    onClickToggleColumns: (index: number) => void;
    tableColumns: WithField[];
    [key: string]: any;
};

export const TableTop = ({
    tableColumns,
    onClickToggleColumns,
    onFilterChange,
    params,
    excelEndpoint,
    filtersStateObject,
    sort,
    downloadExcelPermitted,
    totalCount,
}: TableTopProps) => {
    const [search, setSearch] = useState<string>();
    const [websiteType, setWebsiteType] = useState<string>();
    const { isA2DAvailable } = useNoRenderA2D();

    const handleSearchChange = (search) => {
        setSearch(search);
        onFilterChange({ filter: `domain;contains;"${search?.trim()}"` });
    };
    const handleWebsiteTypeItemClick = (websiteType) => {
        setWebsiteType(websiteType.text);
        onFilterChange({ funcFlag: parseInt(websiteType.id) }, false);
    };

    const handleCloseWebsiteTypeItem = () => {
        setWebsiteType(undefined);
        onFilterChange({ funcFlag: null }, false);
    };

    const handleColumnToggle = (key: string) => {
        const index = tableColumns.findIndex((column) => column.field === key);
        onClickToggleColumns(index);
    };

    const excelLink = downloadExcelPermitted ? resolveExcelLink(excelEndpoint, filtersStateObject, sort) : "";

    return (
        <div>
            <FiltersContainer>
                <WebsiteTypeFilter
                    websiteType={websiteType}
                    onWebsiteTypeItemClick={handleWebsiteTypeItemClick}
                    onCloseWebsiteTypeItem={handleCloseWebsiteTypeItem}
                />
            </FiltersContainer>
            <SearchAndUtils
                search={search}
                onSearchChange={handleSearchChange}
                onClickToggleColumns={handleColumnToggle}
                tableColumns={tableColumns}
                excelLink={excelLink}
                totalCount={totalCount}
                hasPaidExcel={true}
                AddToDashboard={
                    <div>
                        {isA2DAvailable ? (
                            <AddToDashboardWrapper
                                filtersStateObject={filtersStateObject}
                                params={params}
                            />
                        ) : null}
                    </div>
                }
            />
        </div>
    );
};
